export interface FileInfo {
    name: string
    type: string
    size: number
}

export type FileChangeHandler = (file?: File) => void
